module.exports = __webpack_public_path__ + "media/images/svgs/star-cba794a150ea2c0784025252c733e188.svg";